import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import { connect } from 'react-redux';
import postHogFunctions from '~/Classes/posthog.jsx';
@connect((store) => {
    return {
        user: store.user,
        siteMaster: store.siteMaster
    }
})


class RegisterComplete extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        //fbq('track', 'CompleteRegistration');
        postHogFunctions.capture('account_registration', {
            referrer: 'Organic'
        });
    }

    render() {
        var mainMD = 8;
        if (this.props.siteMaster.siteName != "MPZMail" && this.props.siteMaster.siteName != "Transpond") {
            mainMD = 12;
        }


        return (<div className="login-right-panel">
            <div className="login-right-panel-login">
                <Paper className="login-right-panel-login_loginBox">
                    <h3 id="gtm-account-registered" className="mar-b10">Account Registered!</h3>
                    <div className="mar-b40">
                        Welcome to {this.props.siteMaster.siteName}. You can now login and start using the service using login button below. <br /><br />
                        We've also sent you a welcome email. Make sure you click the "Verify" link in the email to start sending campaigns.
                    </div>
                    <Button className="button-primary" onClick={this.props.login}>Login</Button>
                </Paper >
            </div >
        </div >
        )
    }
}
export default RegisterComplete;